<template>
  <div class="container be-part-of">
    <template v-if="isMobile()">
      <div class="row">
        <div class="col-12">
          <img
            v-if="supportsWebP"
            src="/img/be-part-of-1050x981.png.webp"
            srcset="
              /img/be-part-of-340x318.png.webp   680w,
              /img/be-part-of-730x682.png.webp  1460w,
              /img/be-part-of-1050x981.png.webp 2100w
            "
            alt="Be Part Of us"
            loading="lazy"
            width="1050"
            height="981"
            class="img-fluid"
          />
          <img
            v-else
            src="/img/be-part-of-1050x981.png"
            srcset="
              /img/be-part-of-340x318.png   680w,
              /img/be-part-of-730x682.png  1460w,
              /img/be-part-of-1050x981.png 2100w
            "
            alt="Be Part Of us"
            loading="lazy"
            width="1050"
            height="981"
            class="img-fluid"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-10 mx-auto">
          <h2 class="text-center">
            {{ $t("landing.be_part_of.title") }}
          </h2>
          <p>{{ $t("landing.be_part_of.subtitle") }}</p>

          <email-validator :stack="true"></email-validator>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-6 pt-5">
          <h2 class="mt-5">
            {{ $t("landing.be_part_of.title") }}
          </h2>
          <span>{{ $t("landing.be_part_of.subtitle") }}</span>

          <email-validator></email-validator>
        </div>
        <div class="col-6">
          <img
            v-if="supportsWebP"
            src="/img/be-part-of-1050x981.png.webp"
            srcset="
              /img/be-part-of-340x318.png.webp   680w,
              /img/be-part-of-730x682.png.webp  1460w,
              /img/be-part-of-1050x981.png.webp 2100w
            "
            alt="Be Part Of us"
            loading="lazy"
            width="1050"
            height="981"
            class="img-fluid"
          />
          <img
            v-else
            src="/img/be-part-of-1050x981.png"
            srcset="
              /img/be-part-of-340x318.png   680w,
              /img/be-part-of-730x682.png  1460w,
              /img/be-part-of-1050x981.png 2100w
            "
            alt="Be Part Of us"
            loading="lazy"
            width="1050"
            height="981"
            class="img-fluid"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import EmailValidator from "@/components/landing/partials/EmailValidator.vue";

export default {
  name: "BePartOf",
  components: { EmailValidator },
  data() {
    return {
      supportsWebP: this.supportsWebP,
    };
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";

.be-part-of {
  span {
    color: $gray-2;
  }
  p {
    color: $gray-2;
    text-align: center;
  }

  .red-border {
    border: 1px solid red !important;
  }
}
</style>
